import type { ExtensionsConfigOptions } from '../../types';

export const extConfig: ExtensionsConfigOptions = {
  muro: false,
  bold: true,
  italic: true,
  strikethrough: true,
  underline: true,
  bulletList: false,
  orderedList: false,
  horizontalRuler: false,
  link: true,
  emote: true,
  deviation: false,
  deviationThumb: false,
  gallery: false,
  anchor: false,
  blockDragging: false,
  blockquote: false,
  heading: false,
  mention: true,
  paste: true,
  textAlignment: false,
  textColor: false,
  textFont: false,
  textHighlight: false,
  history: true,
  allowUploads: false,
  spinner: true,
  gif: false,
  indent: false,
  daVideo: false,
  hashtag: true,
  characterCount: true,
};
